import { render } from "./ServicesView.vue?vue&type=template&id=811abc92&scoped=true"
import script from "./ServicesView.vue?vue&type=script&lang=js"
export * from "./ServicesView.vue?vue&type=script&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=811abc92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-811abc92"

export default script